export default {"src":"/_next/static/media/Pro-badge.b6158a81.svg","height":68,"width":69};